var _defs, _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 143 45",
    width: 143,
    height: 45,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(22.254,-26.522,13.011,10.918,6.85,40.278)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#e73253"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#f08236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991,
    stopColor: "#f9ba7d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(4.574,8.908,-8.908,4.574,6.934,29.95)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.256,
    stopColor: "#231915",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#291c17",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#37221a",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#50281b",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#722b17",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696,
    stopColor: "#852a12",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726,
    stopColor: "#8f2d13",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.778,
    stopColor: "#ab3415",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.845,
    stopColor: "#dd4217",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.857,
    stopColor: "#e84517",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g3",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(20.996,0,0,23.478,.001,23.083)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002,
    stopColor: "#e73253"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.684,
    stopColor: "#f08236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#f9ba7d"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: url(#g1) } \n\t\t.s1 { fill: url(#g2) } \n\t\t.s2 { fill: url(#g3) } \n\t\t.s3 { fill: #ee7752 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Folder 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m28.7 16.4c0-5.1-6.3-7.4-6.3-7.4l-0.1 14.1c0 2.4-1.6 4.4-3.8 5.1q-0.7 0.2-1.5 0.2-0.6 0-1.2-0.2-0.6-0.1-1.1-0.3c-1-0.5-1.8-1.3-2.3-2.2q-0.3-0.6-0.5-1.3 0-0.1-0.1-0.3-0.1-0.4-0.1-0.8v0.2c-0.1 2.1-0.6 3.9-1.3 5.3-0.1 0.1-1.5 2.7-3.9 4.1 0 0-1.1 0.7-1.7 0.9-0.1 0.1-2.8 0.9-3.3 0.9-0.3 0.1-1.2 0.1-1.2 0.1 0 0 0.5 0 0.5 0h0.7q0 0 0 0c0 0 15.6 0 15.6 0 6 0 11-4.6 11.6-10.4 0-0.4 0-7.9 0-8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m18.6 29.7c0 1.9-0.5 3.7-1.5 5.1q0 0-0.1 0h-3.1-2.2-2.9-1.1-2.8-1.3-2.1q0 0 0 0c-0.1 0-0.9 0-1.3 0q-0.1 0-0.1 0c0-1.4 0-3.2 0-5.1 0-0.4-0.1-0.7 0-1.1 0 0 0.2-0.1 0.2-0.1 1.3 0 2.5-0.5 3.4-1.4 1-0.9 1.6-2.2 1.7-3.6q0-0.3 0-0.6c0.1-0.6 0.1-1.1 0.2-1.7 1.2-0.5 2.3-0.8 3.7-0.8q1.5 0 2.9 0.4c-0.3 0.6-0.5 1.4-0.5 2.3q0 0.1 0 0.2 0 0.4 0.1 0.8 0.1 0.2 0.1 0.3 0.2 0.7 0.5 1.3c0.5 0.9 1.3 1.7 2.3 2.2q0.5 0.2 1.1 0.3 0.6 0.2 1.2 0.2 0.8 0 1.5-0.2 0.1 0.2 0.1 0.4 0 0.6 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m21 12.1v7.2c0 0.1-0.1 0.1-0.2 0.1-0.6-0.6-1.4-1.2-2.4-1.4q-0.6-0.2-1.4-0.2c-1.3 0-2.3 0.5-3 0.9q-0.5 0.4-0.7 0.6c-0.2 0.3-0.7 0.8-1.1 1.5-0.3 0.6-0.5 1.4-0.5 2.3q0 0.1 0 0.2v0.2c0 2.1-0.5 3.9-1.3 5.3-0.1 0.1-0.4 0.7-0.5 0.8 0 0-0.4 0.6-0.5 0.7-0.7 0.9-1.6 1.7-2.5 2.4q-0.2 0.1-0.4 0.2 0 0.1-0.1 0.1-0.9 0.5-1.7 0.9-0.1 0-0.3 0.1-0.4 0.1-0.8 0.3-0.1 0-0.3 0.1-0.1 0-0.2 0-0.9 0.3-1.6 0.3-0.4 0.1-0.7 0.1-0.1 0-0.1 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0h-0.1q0 0 0 0-0.1 0-0.2 0-0.1 0-0.1-0.1v-6.1q0-0.1 0.1-0.1 0-0.1 0.1-0.1c1.3 0 2.5-0.6 3.4-1.4 1-0.9 1.6-2.1 1.7-3.5q0-0.3 0-0.6c0-0.6 0.1-1.1 0.2-1.7 0.1-0.7 0.2-1.4 0.5-2.2 0.8-2.1 2.4-4.3 4.8-5.8 2.6-1.7 5.2-1.9 6.1-1.9 1.3 0 2.4 0.1 4 0.7q0 0 0.1 0 0 0.1 0 0.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m37.5 20.6c0-0.5-0.5-0.9-1.4-0.9-1 0-1.4 0.4-1.4 1 0 1.6 5.2-0.1 5.2 3.7 0 1.7-1.5 3-3.8 3-2.3 0-3.8-1.3-3.8-3h2.2c0 0.6 0.5 1 1.6 1 1.1 0 1.6-0.4 1.6-1 0-1.6-5.3 0.2-5.3-3.7 0-1.7 1.5-2.9 3.7-2.9 2.2 0 3.5 1.2 3.6 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m48.3 23.6c0 2.5-1.5 3.8-3.7 3.8-2.2 0-3.7-1.3-3.7-3.8v-8.6h2.2v3h4.7v2h-4.7v3.6c0 1.2 0.6 1.7 1.5 1.7 0.9 0 1.5-0.5 1.5-1.7v-0.2h2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m58.7 27.1h-2v-1.7h-0.1c-0.5 1.2-1.6 2-3.2 2-2.2 0-4.5-1.6-4.5-4.8 0-2.8 2-4.8 4.9-4.8 2.9 0 4.9 1.9 4.9 4.8zm-2.2-4.5c0-1.6-1.1-2.8-2.7-2.8-1.6 0-2.7 1.2-2.7 2.8 0 1.6 1.1 2.7 2.7 2.7 1.6 0 2.7-1.1 2.7-2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m67.2 25.7c-0.6 1-1.7 1.5-3.1 1.5-2.1 0-4.4-1.4-4.4-4.6 0-2.8 2-4.8 4.9-4.8 2.8 0 4.8 1.9 4.8 4.8v3.8c0 3.5-2.1 4.8-4.8 4.8-2.3 0-4.1-0.9-4.6-3.1h2.2c0.3 0.9 1.2 1.2 2.4 1.2 1.6 0 2.6-0.7 2.6-2.8zm-2.6-5.9c-1.7 0-2.7 1.1-2.7 2.7 0 1.6 1 2.6 2.7 2.6 1.6 0 2.6-1 2.6-2.6 0-1.6-1-2.7-2.6-2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m72.7 23.3v0.1c0.3 1.2 1.2 2 2.6 2q1.5 0 2.1-0.9h2.4c-0.7 1.7-2.4 2.9-4.5 2.9-2.9 0-4.9-2.1-4.9-4.8 0-2.8 2-4.8 4.9-4.8 2.9 0 4.9 2 4.9 4.8v0.7zm0-1.7h5.1c-0.4-1.2-1.3-1.8-2.6-1.8-1.2 0-2.1 0.6-2.5 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m95 22.5c0 2.9-2 4.9-4.9 4.9-2.9 0-4.9-2.1-4.9-4.8 0-3.3 2.3-4.8 4.5-4.8 1.4 0 2.4 0.6 3 1.5h0.1v-5.3h2.2c0 0 0 8.5 0 8.5zm-2.2 0.1c0-1.6-1.1-2.8-2.7-2.8-1.6 0-2.7 1.2-2.7 2.8 0 1.6 1.1 2.7 2.7 2.7 1.6 0 2.7-1.1 2.7-2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m102.1 21.9v-0.1c0-1.4-0.7-2-1.8-2-1.1 0-1.8 0.6-1.8 2v5.3h-2.2v-5.3c0-2.7 1.6-4 4-4 2.4 0 4 1.3 4 4.1 0 0-2.2 0-2.2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m106.4 16.9c-0.8 0-1.5-0.6-1.5-1.4 0-0.8 0.7-1.5 1.5-1.5 0.8 0 1.5 0.7 1.5 1.5 0 0.8-0.7 1.4-1.5 1.4zm-1.1 1.1h2.2v9.1h-2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m112.1 27.1l-3.5-9.1h2.4l2.5 7.1 2.5-7.1h2.4l-3.6 9.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m120.5 16.9c-0.8 0-1.4-0.6-1.4-1.4 0-0.8 0.6-1.5 1.4-1.5 0.8 0 1.5 0.7 1.5 1.5 0 0.8-0.7 1.4-1.5 1.4zm-1.1 1.1h2.2v9.1h-2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m130.1 27.1v-4.7c0-1.8-1-2.6-2.3-2.6-1.4 0-2.3 0.8-2.3 2.6v4.7h-2.2v-4.7c0-3.1 1.8-4.6 4.5-4.6 2.7 0 4.5 1.5 4.5 4.6v4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m140.8 25.7c-0.6 1-1.7 1.5-3.1 1.5-2.1 0-4.5-1.4-4.5-4.6 0-2.8 2.1-4.8 4.9-4.8 2.9 0 4.9 1.9 4.9 4.8v3.8c0 3.5-2.2 4.8-4.8 4.8-2.3 0-4.1-0.9-4.6-3.1h2.2c0.3 0.9 1.2 1.2 2.4 1.2 1.6 0 2.6-0.7 2.6-2.8zm-2.7-5.9c-1.6 0-2.7 1.1-2.7 2.7 0 1.6 1.1 2.6 2.7 2.6 1.6 0 2.7-1 2.7-2.6 0-1.6-1.1-2.7-2.7-2.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.55cda4ee2584e1fba874d940342f11e9.svg";
export { ForwardRef as ReactComponent };